<template>
  <b-modal
    title="Info"
    ref="info-modal"
    id="info-modal"
    size="lg"
    ok-title="닫기"
    @ok="closeClick"
    cancel-title="오늘 하루 그만 보기"
    @cancel="cancelClick"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <b-row>
        <b-col>
          <h3>서비스 출처</h3>
          <li style='font-size: 1.2rem; list-style-type: none;'>서비스 회사: 검색 데이터 분석기업 업트래닉스</li>
          <li style='font-size: 1.2rem; list-style-type: none;'>서비스 명칭: ‘2026지방선거 in SEARCH Ai’</li>

          <h3 style="margin-top: 2rem;">그 범위와 정보 정의</h3>
          <li style='font-size: 1.2rem; list-style-type: none;'><font style="font-weight: bold;">분석 범위:</font> <font style="color: #7367f0; font-weight: bold;">네이버 통합검색의 추정 검색량 데이터</font></li>
          <li style='font-size: 1.2rem; list-style-type: none;'><font style="font-weight: bold;">검색 점유율:</font> <font style="color: #7367f0; font-weight: bold;">해당 후보(또는 정당)의 검색량 / 수집되는 후보 검색량의 총 합</font></li>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput, BCol, BRow } from "bootstrap-vue";

export default {
  name: "InfoModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BCol,
    BRow,
  },
  props: {
    // modalData: {
    //   type: Number,
    //   default: 1,
    // },
  },
  data() {
    return {
      
    };
  },
  methods: {
    
    closeClick(){
      console.log('closeClick')
      this.$bvModal.hide("info-modal");
    },

    cancelClick(){
      console.log('cancelClick')
      this.setCookie('votecookie', 'popupEnd', 1)
      this.$bvModal.hide("info-modal");
    },

    setCookie(name, value, expiredays){
      // var today = new Date();
      // console.log(today.getDate())
      // today.setDate(today.getDate() + expiredays); // 현재시간에 하루를 더함 

      var todayDate = new Date(); todayDate = new Date(parseInt(todayDate.getTime() / 86400000) * 86400000 + 54000000);

            if (todayDate > new Date()) {
                expiredays = expiredays - 1;
            }

            todayDate.setDate(todayDate.getDate() + expiredays);


      document.cookie = name + '=' + escape(value) + '; expires=' + todayDate.toGMTString();
    }

    

  },
  created() {
    
    
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}


#info-modal___BV_modal_footer_ > button.btn.btn-secondary, #info-modal___BV_modal_footer_ > button.btn.btn-primary {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
}

#info-modal___BV_modal_footer_ {
  justify-content: space-between;
}

#info-modal___BV_modal_body_ {
  padding : 0
}

/* #info-modal___BV_modal_content_ {
  margin-left: 10rem;
  width: 70%;
} */

</style>